document.querySelectorAll('.footer__item--currency .select__item_currency').forEach(el => el.addEventListener('click', (e)=> {
    const parent = el.parentNode.closest('.select.select--light')
    const trigger = parent.querySelector('.select__wrap.js-open-select')
    const list = parent.querySelector('.select__menu')
      trigger.classList.remove('active')
      list.style.display = 'none'

  }))

  function btnFooter() {
    var parent = document.querySelector('.footer');
    if (!parent) return;
    var title = parent.querySelectorAll('.js-item-btn');
    if (!title.length) return;
    title.forEach(function (btn) {
        var list = btn.nextElementSibling,
            itemList = list.querySelectorAll('.list__item');
        var height = 0;
        itemList.forEach(function (el) {
        var marginTop = +window.getComputedStyle(el).marginTop.replace('px', ''),
            marginbottom = +window.getComputedStyle(el).marginBottom.replace('px', '');
        height += el.offsetHeight + marginTop + marginbottom;
        });
        btn.addEventListener('click', function (e) {
        var targrt = e.currentTarget;
        var width = $(window).width();
        if (width > 768) return;

        if (targrt.classList.contains('active')) {
            targrt.classList.remove('active');
            list.style.maxHeight = '0';
        } else {
            targrt.classList.add('active');
            list.style.maxHeight = height + 80 + 'px';
        }
        });
    });
  }

  btnFooter();